import Link from 'next/link';

interface Props {
  children: React.ReactNode;
  href: string;
  prefetch?: boolean;
  target?: '_blank' | '_self' | '_parent' | '_top';
}

export default function BurnoutStyledLinkNext({ children, href, prefetch = true, target }: Props) {
  return (
    <Link
      prefetch={prefetch}
      href={href}
      className='text-burnout-red hover:text-burnout-light-red burnout_gradient_underline'
      target={target}
    >
      {children}
    </Link>
  );
}
